/**
 * The v2 game's documented defaults, in one place (`docs/architecture/siege-v2-proposal.md` § Game
 * model, R-113/R-114/R-121; the server's `Mha__Game__*` options).
 *
 * Three readers need them and none may invent its own copy: the demo simulator (which runs the
 * game), the store (which bumps the odometer by `SpawnPerClick` on a press) and the wall bars
 * (which drain between ticks against the wall's full health). None of these numbers is on the wire
 * yet, so a server tuned away from them is not something this client can know about — which is why
 * every use is a *display* use that the next frame snaps over, never a settled value.
 */

/**
 * The live scene's gate (2026-09-05, `docs/architecture/sieges.md` § "The gate has health"):
 * the crowd cap `Mha__Game__BreachThreshold` and the gate's health `Mha__Game__GateHp` in
 * zombie-seconds. Forty zombies at one damage per second empty the gate in a minute.
 */
export const CROWD_CAP = 40
export const GATE_HP = 2_400

/** Zombies one accepted click spawns. */
export const SPAWN_PER_CLICK = 1

/** Damage per zombie per second, in zombie-seconds per second. */
export const DPS = 1

/** Health of each wall in zombie-seconds, outer wall first. */
export const WALL_HP: readonly number[] = [1_000_000, 10_000_000, 100_000_000]

export const WALL_COUNT = 3
